<template>
  <div id="familyAdd">
      <v-layout wrap row mb-1>
      <v-flex md6 style="min-height:70px;">
        <v-btn fab left to="/admin/families" class="ml-3 pf-btn-fab">
          <v-icon>arrow_back</v-icon>
        </v-btn>
         </v-flex>
    </v-layout>
    <v-form ref="familyAdd">
      <v-container>
        <v-layout wrap class="pr-4 pl-4">
            <v-flex xs12 sm6 md6 pl-0>
              <div class="pt-2">
                  <div class="mt-0 left pr-3 switch-account">
                    <v-label class="">Account Type</v-label>
                  </div>
                  <div class="pt-1">  
                     <label class="switch-cover">
                      <input type="radio" v-model="newUser.account_type" name="radio" id="couple" value="Couple" @change="changeAccountType($event.target.value)">
                      <span class="checkmark">Couple</span>
                    </label>
                    <label class="switch-cover">
                      <input type="radio" v-model="newUser.account_type" id="single" name="radio" value="Single" @change="changeAccountType($event.target.value)">
                      <span class="checkmark">Single</span>
                    </label>
                  </div>
              </div>
            </v-flex>
            <v-flex xs12 sm6 md6 class="button-container pr-0 text-xs-right hidden-xs-only">
              <div class="d-inline-flex" v-if="selectedData">
                <v-btn class="pf-btn pf-btn-cancel" to="/admin/families">
                  <v-icon size="16" class="pr-1">cancel</v-icon>
                  <div>Cancel</div>
                </v-btn>
                <v-btn class="pf-btn pf-btn-save" @click="save">
                  <v-icon size="16" class="pr-1">check_circle</v-icon>
                  <div>Save</div>
                </v-btn>
              </div>
            </v-flex>
        </v-layout>
        <v-layout wrap class="pb-4 pt-3">
          <v-flex xs12 sm12 class="pr-4 pl-4">
              <h5 v-if="newUser.account_type === 'Couple'" class="text-uppercase font-weight-bold">Couple 1</h5>
            </v-flex>
            <v-flex xs12 sm6 md4>
              <v-text-field v-model.trim="newUser.firstname1" :rules="rules" label="First Name"
              class="required pr-4 pl-4" @input="changedData"></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md4>
              <v-text-field v-model="newUser.lastname1" :rules="rulesLastname" label="Last Name" class="pr-4 pl-4 required" @input="changedData"></v-text-field>
            </v-flex>
        </v-layout>
        <v-layout wrap class="pb-4 pt-3" v-if="newUser.account_type === 'Couple'">
          <v-flex xs12 sm12 class="pr-4 pl-4">
              <h5 class="text-uppercase font-weight-bold">Couple 2</h5>
            </v-flex>
            <v-flex xs12 sm6 md4>
              <v-text-field v-model.trim="newUser.firstname2" :rules="rules" label="First Name"
              class="required pr-4 pl-4" @input="changedData"></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md4>
              <v-text-field v-model="newUser.lastname2" :rules="rulesLastname" label="Last Name" class="pr-4 pl-4 required" @input="changedData"></v-text-field>
            </v-flex>
        </v-layout>
        <v-layout wrap class="pb-4 pt-3">
          <v-flex xs12 sm6 md8>
            <v-select @change="changedData" :rules="membershipRules" v-model="newUser.membership" :items="membershipList" label="Membership" class="required pr-4 pl-4" required></v-select>
          </v-flex>
        </v-layout>
         <v-layout wrap class="pb-4 pt-3">
           <v-flex xs12 sm6 md4>
              <v-text-field @blur="duplicateUserNameChecking" :success-messages="this.usernameFlag ? 'username is available': ''" browser-autocomplete="new-username" v-model.trim="newUser.username" :rules="rules" label="User Name"
              class="required pr-4 pl-4" @input="changedData"></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md4>
              <v-text-field ref="password"
                browser-autocomplete="new-password"
                autocomplete="off"
                :append-icon="show1 ? 'visibility' : 'visibility_off'"
                :rules="enterPasswordRules"
                :type="show1 ? 'text' : 'password'"
                @click:append="show1 = !show1"
                @input="changedData"
                class="required pr-4 pl-4 pb-4"
                hint="At least 8 characters"
                label="Enter Password"
                placeholder="password"
                v-model="newUser.password"
              ></v-text-field>
            </v-flex>
         </v-layout>
          <v-layout wrap class="pb-4 pt-3">
           <v-flex xs12 sm6 md4>
              <v-text-field @blur="duplicateEmailChecking" :success-messages="this.emailFlag ? 'email is available': ''" v-model.trim="newUser.email" :rules="[emailRules]" label="Email"
              class="required pr-4 pl-4" @input="changedData"></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md4>
              <v-autocomplete
                  label="Agency" 
                  class="required pr-4 pl-4"
                  item-text="name"
                  item-value="_id"
                  :items="AgencyList"
                  :rules="rulesAgency"
                  v-model="newUser.agency"
                  @change="changedData">
                </v-autocomplete>
            </v-flex>
         </v-layout>
      </v-container>
    <v-container>
      <v-layout wrap class="pr-4 pl-4">
        <v-flex xs12 sm6 md6 pl-0></v-flex>
        <v-flex xs12 sm6 md6 class="button-container pr-0 text-xs-right" v-if="selectedData">
          <div class="d-inline-flex">
            <v-btn class="pf-btn pf-btn-cancel" to="/admin/families">
              <v-icon size="16" class="pr-1">cancel</v-icon>
              <div>Cancel</div>
            </v-btn>
            <v-btn class="pf-btn pf-btn-save" @click="save">
              <v-icon size="16" class="pr-1">check_circle</v-icon>
              <div>Save</div>
            </v-btn>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
    </v-form>
  </div>
</template>

<script>
/* global session store config */
import { create, getCollection, validateUrl, requestToWPPF, checkWPToken } from '../../helpers/helpers';
import swal from 'sweetalert2';
import Vue from 'vue';
import { mapGetters } from 'vuex';
import generatePassword from 'generate-password';

export default {
  name: 'familyAdd',
  data: () => ({
    selectedData: true,
    usernameFlag: false,
    emailFlag: false,
    show1: false,
    config: config,
    newUser: {
      account_type: 'Single',
      firstname1: '',
      lastname1: '',
      firstname2: '',
      lastname2: '',
      username: '',
      password: '',
      email: '',
      membership: '',
      agency: '',
    },
    membershipList: [
      'Network',
      'Featured',
      'Preferred'
    ],
    rulesLastname: [
      v => !!v || 'Last name is required'
    ],
    rulesAgency: [
      v => !!v || 'Agency is required'
    ],
    membershipRules: [
      v => !!v || 'membership is required'
    ],
    rules: [
      v => !!v || 'First name is required'
    ],
    rulesPswd: [
      v => !!v || 'Password is required'
    ],
    emailRules: (v) => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,5})+$/.test(v) || 'Please enter valid email address',
  }),
  computed: {
    ...mapGetters(['Agency']),
    AgencyList: {
      set (value) {
        store.commit('setAgencyList', value);
      },
      get () {
        return store.state.AgencyList;
      }
    },
    enterPasswordRules () {
      return [
        v => !!v || 'Field is required.',
        v => !!v && v.length >= 8 || 'Password cannot be less than 8 characters',
        v => /(?=.*?[A-Z])/.test(v) || 'Password must have upper case letter',
        v => /(?=.*?[0-9])/.test(v) || 'Password must have one number'
      ];
    },
  },
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  created () {
    this.initialize();
    this.newUser.password = generatePassword.generate({
      length: 8,
      uppercase: true,
      numbers: true,
      lowercase: true,
      strict: true
    });
  },
  mounted () {
    window.getApp.$emit('pageSubHeader', 'Add');
  },
  methods: {
    // @vuese
    // Used to initialize the agency list if not exists.
    async initialize () {
      if (!this.AgencyList.length) {
        let where = { _id: { $ne: this.Agency.id }, is_admin: false };
        let attributes = 'name,nickname,email,createdAt,_id';
        let populate = [{ path: 'human', select: '_id user' }];
        let { error, data } = await getCollection('Agency', true, 0, populate, where, attributes);
        if (error) {
          console.log(error);
          this.snackbar = {
            show: true,
            color: 'red',
            text: 'Failed to load client list'
          };
        } else {
          if (data.length > 0) {
            store.commit('setAgencyList', data);
          }
        }
      }
    },
    async duplicateEmailChecking () {
      this.emailFlag = false;
      if (this.newUser.email.length && await checkWPToken()) {
        const emailUrl = `${this.config.WPParams.api.url}pf/v1/emailexists?email=${this.newUser.email}`;
        const response = await requestToWPPF(emailUrl, 'GET');
        if (response.error) {
          console.log(response.error);
        } else {
          if (response.count > 0) {
            swal.fire({
              title: 'The email already exists',
              type: 'error',
              confirmButtonColor: '#3085d6',
              confirmButtonText: 'Close',
              allowOutsideClick: false
            }).then((result) => {
              if (result.value) {
                this.newUser.email = '';
              }
            });
          } else {
            this.emailFlag = true;
          }
        }
      }
    },
    async duplicateUserNameChecking () {
      this.usernameFlag = false;
      if (this.newUser.username.length && await checkWPToken()) {
        const usernameUrl = `${this.config.WPParams.api.url}pf/v1/usernameexists?username=${this.newUser.username}`;
        const response = await requestToWPPF(usernameUrl, 'GET');
        if (response.error) {
          console.log(response.error);
        } else {
          if (response.count > 0) {
            swal.fire({
              title: 'The username already exists',
              type: 'error',
              confirmButtonColor: '#3085d6',
              confirmButtonText: 'Close',
              allowOutsideClick: false
            }).then((result) => {
              if (result.value) {
                this.newUser.username = '';
              }
            });
          } else {
            this.usernameFlag = true;
          }
        }
      }
    },
    async save () {
      if (this.$refs.familyAdd.validate() && await checkWPToken()) {
        if (this.newUser.account_type === 'Single') {
          delete this.newUser.firstname2;
          delete this.newUser.lastname2;
        }
        let userCreation = this.config.WPParams.api.url + 'pf/v1/users/register';
        let response = await requestToWPPF(userCreation, 'POST', this.newUser);
        if (response.error) {
          this.newUser.firstname2 = '';
          this.newUser.lastname2 = '';
          swal.fire({
            type: 'warning',
            title: '<b>Error</b>',
            html: response.message,
            showConfirmButton: false,
            timer: 2500,
            onClose: () => {
              // 
            }
          });
        } else {
          swal.fire({
            type: 'success',
            title: '<b>Success</b>',
            html: response.message,
            showConfirmButton: false,
            timer: 2500,
            onClose: () => {
              this.$router.push({ path: '/admin/families' });
            }
          });
        }
      }
    },
    changedData (value) {
      this.selectedData = true;
    },
    changeAccountType (value) {
      this.selectedData = true;
    }
  }
};
</script>

<style lang="css" scoped>

  .button-container{
    min-height: 60px;
  }
  .account-type{
    padding-top: 2px;
  }
  .switch-account{
    padding-top: 5px;
  }

  .switch-cover {
    cursor: pointer;
    float:left;
  }
  .switch-cover input {
      position: absolute;
      opacity: 0;
  }
  .checkmark {
      background-color: #eff0f4;
      padding: 6px 20px;
  }
  .switch-cover:hover input ~ .checkmark {
    background-color: #ccc;
  }
  .switch-cover input:checked ~ .checkmark {
    background-color: #019d8c;
    color: #fff;
  }
  .switch-cover input:checked ~ .checkmark:after {
    display: block;
  }
  @media(max-width:410px){
    .switch-account{
      padding-right: 0 !important;
      width: 100%;
      padding-bottom: 15px;
    }
    .pf-btn{
      min-width: 85px;
    }
  }
  @media(min-width: 600px) and (max-width:699px){
    .switch-account{
      padding-right: 0 !important;
      width: 100%;
      padding-bottom: 15px;
    }
  }
</style>




// WEBPACK FOOTER //
// src/pages/Families/add.vue